import debounce from "lodash.debounce";

/* global $ */
/**
 * Make sure the legacy scripts are included!
 *
 *   <script src="/static/js/jquery-3.5.1.min.js"></script>
 *   <script src="/static/js/owl.carousel.min.js"></script>
 *   <link rel="stylesheet" href="/static/css/owl.carousel.min.css" />
 *   <link rel="stylesheet" href="/static/css/owl.theme.default.min.css" />
 */

export default function initCarousels() {
  try {
    Array.from(document.querySelectorAll(".js-carousel")).forEach(
      (el, index) => {
        initCarousel(el);
      },
    );
  } catch (e) {
    console.error(e);
  }
}

function initCarousel(el) {
  const element = el;
  const isExperienceEditor = document
    .querySelector("body")
    .classList.contains("is-page-editor");

  if (!isExperienceEditor) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("carousel__card--placeholder");
    element.appendChild(newDiv);
    $(element).owlCarousel({
      autoWidth: true,
      margin: 20,
      nav: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>',
      ],
    });
    resizeCarousels(element);

    const debouncedResize = debounce(() => resizeCarousels(element), 150);

    $(window).resize(debouncedResize);
  } else {
    $(".js-carousel").addClass("owl-carousel--experience-editor");
  }

  function resizeCarousels(el) {
    const container = $(el).siblings(".js-carousel-full");

    const marginLeft =
      container && container.length
        ? parseInt(container.css("margin-left"))
        : 0;

    $(el).find(".owl-stage").css("margin-left", marginLeft);
    $(el)
      .find(".owl-stage")
      .width($(".owl-stage").width() + marginLeft + 300);

    // adjust prev/next nav chevrons
    const width = ($(".owl-dot").length * 26) / 2 + 10;

    $(el)
      .find(".owl-prev")
      .css({
        left: "-" + width + "px",
      });

    $(el)
      .find(".owl-next")
      .css({
        left: width + "px",
      });
  }
}
